//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
// import TagManager from 'react-gtm-module';

//components
import Alerta from '../../../../../util/snackbars/.mixins/';
import Section from '../childrens/Section/.mixins/';

//constrollers
import CondicaoPagamentoController from '../../../../../../controllers/condicoesPagamento';

import Log from '../../../../../../controllers/log';

export default class GrupoOpcoesRecebimento_ae extends Component {

    constructor(props) {
        super(props);
        
        this.child = React.createRef();

        this.state = {
            tipo: 'Adicionar',
            isLoading: false,
            nome: '',
            flagCondicaoPadrao: true,
            nomeCondicaoPadraoAtrelada: '',
            condicaoPadraoAtrelada : null,
            prazoAtendimento: 0,
            percentualDesconto: 0,
            listaCondicoes: [],
            oneClick: false,
        }
        
        this.getLista();
        if (this.props && this.props.params && this.props.params.id) {
            this.state.tipo = 'Editar';
            this.state.isLoading = true;
            this.getOne(this.props.params.id);
        }

        this.setState = this.setState.bind(this);
        this.validacao = this.validacao.bind(this);
        this.send = this.send.bind(this);
        this.handleCondicaoPadrao = this.handleCondicaoPadrao.bind(this);
        this.handlerSwitchToggle = this.handlerSwitchToggle.bind(this);
    };

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:grupo-opcoes-recebimento',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-grupo-opcoes-recebimento',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela formulário de condições de pagamento!");
    };

    handlerSwitchToggle = () => {
        this.setState({flagCondicaoPadrao: !this.state.flagCondicaoPadrao});
    };

    handleCondicaoPadrao = (e,v) => {
        if (v == null) { 
            this.setState({ 
                condicaoPadraoAtrelada: null 
            });
        }else {
            this.setState({
                condicaoPadraoAtrelada: v.CD_PAGTO,
            });
        }
    };

    handlePrazoAtendimento = (e) => {
        this.setState({prazoAtendimento: e.target.value});
    };

    handlePercentualDesconto = (e) => {
        this.setState({percentualDesconto: e.target.value});
    };
    
    ValidaNumber = (e) => {
        return (e === "" || e.match(/^(0)+$/))
    }

    async validacao() {
        return new Promise((resolve,reject)=>{
            if (this.state.nome === "" || this.state.nome.match(/^(\s)+$/)) {
                this.child.current.retorno('Preencha o campo de nome da condição!','warning');
                resolve(false);
            }
            if (this.ValidaNumber(this.state.prazoAtendimento)) {
                this.child.current.retorno('Preencha o campo de prazo de atendimento corretamente!','warning');
                resolve(false);
            }

            if (this.state.flagCondicaoPadrao) {

                if (this.state.condicaoPadraoAtrelada === 0 ||
                    !this.state.condicaoPadraoAtrelada) {
                        this.child.current.retorno('Preencha o campo de condição padrão atrelada!','warning');
                        resolve(false);
                }
                if (this.ValidaNumber(this.state.percentualDesconto) ||
                    parseFloat(this.state.percentualDesconto) > 100) {
                        this.child.current.retorno('Preencha o campo de percentual desconto corretamente!','warning');
                        resolve(false);
                }
            }
            resolve(true);
        });
    };

    async send() {
        // valida se campos obrigatórios foram enviados
        const valid = await this.validacao();
        if (!valid){
            this.setState({
                oneClick: false,
            });
            return
        };
        this.setState({oneClick: true})
        if (this.state.tipo === 'Adicionar') {
            this.post();
        } else {
            this.put(this.props.params.id);
        }

    };

    async post() {
        //instancia cookies e captura user-token para fazer request
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            //recupera dados de grupos
            const body = {
                Cd_pagto_padrao_org: this.state.condicaoPadraoAtrelada,
                Nr_prazo: this.state.prazoAtendimento,
                Vp_desc_antec_pagto: this.state.percentualDesconto,
                In_cond_padrao_org: !this.state.flagCondicaoPadrao?"S":"N",
                Tx_obs: this.state.nome
            };
            const r_condicao = await CondicaoPagamentoController.postCondicao(token,body);

            //convert dados de condicaos para object
            const j_r_condicao = JSON.parse(r_condicao.body);

            //valida resultado da consulta
            if (r_condicao.res.statusCode == 200) {
                const sucessString = 'Feito inserção de condição!';
                this.setState({
                    isLoading: false,
                });
                this.child.current.retorno(sucessString,'success');
                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:manutencao-condicoes-pagamento',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:${sucessString}`,
                //     }
                // });
                setTimeout(() => {
                    this.props.router.goBack();
                }, 1000);
            } else if (j_r_condicao.message === 'Token inválido!') {
                this.child.current.retorno('Autentificação inválida!','error');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                this.child.current.retorno('Não foi possível inserir os dados!','error');
            }
        } catch (error) {
            this.child.current.retorno('Erro na inserção de dados de condições!','error');

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:manutencao-condicoes-pagamento',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            let str = "Erro na inserção de dados de condições! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }
    };

    async put(id) {
        //instancia cookies e captura user-token para fazer request
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            //recupera dados de grupos
            const body = {
                Cd_pagto: id,
                Cd_pagto_padrao_org: this.state.condicaoPadraoAtrelada,
                Nr_prazo: this.state.prazoAtendimento,
                Vp_desc_antec_pagto: this.state.percentualDesconto,
                In_cond_padrao_org: !this.state.flagCondicaoPadrao?"S":"N",
                Tx_obs: this.state.nome
            };
            const r_condicao = await CondicaoPagamentoController.putCondicao(token,body);

            //convert dados de condicaos para object
            const j_r_condicao = JSON.parse(r_condicao.body);

            //valida resultado da consulta
            if (r_condicao.res.statusCode == 200) {
                const sucessString = 'Feito edição de condição!';
                this.setState({
                    isLoading: false,
                });
                this.child.current.retorno(sucessString,'success');
                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:manutencao-condicoes-pagamento',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:${id}:${sucessString}`,
                //     }
                // });
                setTimeout(() => {
                    this.props.router.goBack();
                }, 1000);
            } else if (j_r_condicao.message === 'Token inválido!') {
                this.child.current.retorno('Autentificação inválida!','error');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                this.child.current.retorno('Não foi possível editar os dados!','error');
            }
        } catch (error) {
            this.child.current.retorno('Erro na edição de dados de condições!','error');

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:manutencao-condicoes-pagamento',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${id}:${error.message}`,
            //     }
            // });

            //auditoria
            let str = "Erro na edição de dados de condições! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }
    };

    async getOne(id) {
        //instancia cookies e captura user-token para fazer request
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            //recupera dados de grupos
            const r_condicao = await CondicaoPagamentoController.getOneCondicao(token,id);

            //convert dados de condicaos para object
            const j_r_condicao = JSON.parse(r_condicao.body);
            
            //valida resultado da consulta
            if (r_condicao.res.statusCode == 200) {
                this.setState({
                    nome: j_r_condicao.NM_COND_PAGTO,
                    nameCondicaoPadraoAtrelada: j_r_condicao.NM_COND_PAGTO_PADRAO,
                    flagCondicaoPadrao: j_r_condicao.IN_COND_PADRAO_ORG == 'N'?true:false,
                    condicaoPadraoAtrelada: j_r_condicao.CD_PAGTO_PADRAO,
                    prazoAtendimento: j_r_condicao.NR_DIAS_PRAZO,
                    percentualDesconto: j_r_condicao.VP_DESCONTO.replace(",", "."),
                    isLoading: false,
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:manutencao-condicoes-pagamento',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:${id}:${j_r_condicao.NM_COND_PAGTO}`,
                //     }
                // });
            } else if (j_r_condicao.message === 'Token inválido!') {
                this.child.current.retorno('Autentificação inválida!','error');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                this.child.current.retorno('Não foi possível carregador os dados!','error');
            }
        } catch (error) {
            this.child.current.retorno('Erro na recuperação de dados de condições!','error');

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:manutencao-condicoes-pagamento',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${id}:${error.message}`,
            //     }
            // });

            //auditoria
            let str = "Erro na recuperação de dados de condições! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    };

    async getLista() {
        //instancia cookies e captura user-token para fazer request
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            //recupera dados de grupos
            const r_condicao = await CondicaoPagamentoController.getListaCondicoes(token);

            //convert dados de condicaos para object
            const j_r_condicao = JSON.parse(r_condicao.body);

            //valida resultado da consulta
            if (r_condicao.res.statusCode == 200) {
                this.setState({
                    listaCondicoes: j_r_condicao,
                    isLoading: false,
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:manutencao-condicoes-pagamento',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:lista-condicoes`,
                //     }
                // });
            } else if (j_r_condicao.message === 'Token inválido!') {
                this.child.current.retorno('Autentificação inválida!','error');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                this.child.current.retorno('Não foi possível carregador os dados!','error');
            }
        } catch (error) {
            this.child.current.retorno('Erro na recuperação de dados de condições!','error');

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:manutencao-condicoes-pagamento',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            let str = "Erro na recuperação de dados de condições! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    };

    render() {
        return (
            <>
                <Section {...this}/>
                <Alerta ref={this.child}/>
            </>
        );
    }
}
